import { render } from "./AllergensTable.vue?vue&type=template&id=b75a3ad8&scoped=true&ts=true"
import script from "./AllergensTable.vue?vue&type=script&lang=ts"
export * from "./AllergensTable.vue?vue&type=script&lang=ts"

import "./AllergensTable.vue?vue&type=style&index=0&id=b75a3ad8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75a3ad8"]])

export default __exports__